import React from 'react';
import { PeriodicReportingType } from '../PeriodicReporting';
import PeriodicReportingUpdateModal from './PeriodicReportingUpdateModal';
import PeriodicReportingDeleteModal from './PeriodicReportingDeleteModal';

interface PeriodicReportingActionCellProps {
	data: PeriodicReportingType;
	fetchData: () => void;
	fetchTotals?: () => void;
	isCoordinator?: boolean;
	state: 'DRAFT' | 'VALIDATED';
	isEnabledToView: boolean;
	isBeneficiary: boolean;
	isProjectWp: boolean;
	userCompanies?: number[];
	projectIndirectCostsPerc: number;
}

const PeriodicReportingActionCell: React.FC<PeriodicReportingActionCellProps> = ({
	data,
	fetchData,
	fetchTotals,
	isCoordinator,
	state,
	isEnabledToView,
	isBeneficiary,
	isProjectWp,
	userCompanies,
	projectIndirectCostsPerc,
}) => {
	return (
		<div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
			<PeriodicReportingUpdateModal
				data={data}
				fetchData={fetchData}
				fetchTotals={fetchTotals}
				isCoordinator={isCoordinator}
				state={state}
				isEnabledToView={isEnabledToView}
				isBeneficiary={isBeneficiary}
				isProjectWp={isProjectWp}
				userCompanies={userCompanies}
				projectIndirectCostsPerc={projectIndirectCostsPerc}
			/>
			{state === 'DRAFT' && !(isBeneficiary && !isEnabledToView) ? (
				<PeriodicReportingDeleteModal data={data} fetchData={fetchData} />
			) : null}
		</div>
	);
};

export default PeriodicReportingActionCell;
